import fetch from './api'
import $hostInfo from './hostInfo.js'
let host = $hostInfo.host;
// 登录
export const login = data => fetch(host + '/login', data, { isLogin: true });

// 退出登录
export const logout = data => fetch(host + '/logout', data, { isLogin: true });

// 修改密码
export const updatePwd = data => fetch(host + '/user/profile/updatePwd', data, { method: 'put', param: data });

// 获取登录信息
export const getInfo = data => fetch(host + '/getInfo', data, { isLogin: true, method: 'get' });

// 获取路由列表
export const getRouters = data => fetch(host + '/getRouters/1', data, { method: 'get' });

// 获取省市区列表
export const regionAll = data => fetch(host + '/region/tree', data, { method: 'get' });

// 根据用户id获取详细信息
export const getUserInfo = userId => fetch(host + `/user/${userId}`, {}, { method: 'get' });

// 获取菜单列表
export const menuList = data => fetch(host + '/menu/list', data, { method: 'get' });

// 新增菜单
export const addMenu = data => fetch(host + '/menu', data);

// 修改菜单
export const updateMenu = data => fetch(host + '/menu', data, { method: 'put' });

// 删除菜单
export const deleteMenu = menuId => fetch(host + '/menu/' + menuId, {}, { method: 'delete' });

// 角色列表
export const roleList = data => fetch(host + '/role/list', data, { method: 'get' });

// 添加角色
export const addRole = data => fetch(host + '/role', data);

// 修改角色
export const updateRole = data => fetch(host + '/role', data, { method: 'put' });

// 修改角色
export const getRoleMenuTreeSelect = roleId => fetch(host + `/menu/roleMenuTreeselect/${roleId}`, {}, { method: 'get' });

// 删除角色
export const deleteRole = roleIds => fetch(host + `/role/${roleIds}`, {}, { method: 'DELETE' });

// 系统参数配置 - 列表（分页）
export const configList = data => fetch(host + '/config/list', data, { method: 'get' });

// 系统参数配置 - 新增
export const addConfig = data => fetch(host + '/config', data);

// 系统参数配置 - 修改
export const updateConfig = data => fetch(host + '/config', data, { method: 'put' });

// 系统参数配置 - 删除（批量，逗号分隔）
export const deleteConfig = ids => fetch(host + `/config/${ids}`, {}, { method: 'DELETE' });

// 系统参数配置 - 根据ID获取详情
export const getConfigById = id => fetch(host + `/config/${id}`, {}, { method: 'get' });

// 用户列表
export const userList = data => fetch(host + '/user/list', data, { method: 'get' });

// 删除用户
export const deleteUser = userIds => fetch(host + `/user/${userIds}`, {}, { method: 'DELETE' });

// 添加用户
export const addUser = data => fetch(host + '/user', data, { method: 'post' });

// 修改用户
export const updateUse = data => fetch(host + '/user', data, { method: 'put' });

// 用户密码重置
export const UserPwd = data => fetch(host + '/user/resetPwd', data, { method: 'put' });

// 系统设置-操作日志列表
export const operLogList = data => fetch(host + `/operLog/list`, data, { method: 'get' });

// 字典数据 - 列表（分页）
export const dictDataList = data => fetch(host + '/dict/data/list', data, { method: 'get' });

// 字典数据 - 新增
export const addDictData = data => fetch(host + '/dict/data', data, { method: 'post' });

// 字典数据 - 修改
export const updateDictData = data => fetch(host + '/dict/data', data, { method: 'put' });

// 字典数据 - 删除（批量，逗号分隔）
export const deleteDictData = ids => fetch(host + `/dict/data/${ids}`, {}, { method: 'DELETE' });

// 字典数据 - 根据ID获取详情
export const getDictDataById = id => fetch(host + `/dict/data/${id}`, {}, { method: 'get' });

// 字典类型 - 列表（分页）
export const dictTypeList = data => fetch(host + '/dict/type/list', data, { method: 'get' });

// 字典类型 - 新增
export const addDictType = data => fetch(host + '/dict/type', data, { method: 'post' });

// 字典类型 - 修改
export const updateDictType = data => fetch(host + '/dict/type', data, { method: 'put' });

// 字典类型 - 删除（批量，逗号分隔）
export const deleteDictType = ids => fetch(host + `/dict/type/${ids}`, {}, { method: 'DELETE' });

// 字典类型 - 根据ID获取详情
export const getDictTypeById = id => fetch(host + `/dict/type/${id}`, {}, { method: 'get' });

// 权益组合 - 分页查询
export const quityGroupPage = data => fetch(host + '/quityGroup/page', data, { method: 'post' });

// 权益组合 - 查询详情
export const getQuityGroupById = id => fetch(host + `/quityGroup/${id}`, {}, { method: 'get' });

// 权益组合 - 创建
export const addQuityGroup = data => fetch(host + '/quityGroup', data, { method: 'post' });

// 权益组合 - 编辑
export const editQuityGroup = data => fetch(host + '/quityGroup/edit', data, { method: 'post' });

// 权益组合 - 重新提交审核
export const resubmitQuityGroup = data => fetch(host + '/quityGroup/resubmit', data, { method: 'post' });

// 权益组合 - 审核
export const auditQuityGroup = data => fetch(host + '/quityGroup/audit', data, { method: 'post' });

// 权益组合 - 上下架
export const shelfQuityGroup = data => fetch(host + '/quityGroup/shelf', data, { method: 'post' });

// 权益组合 - 状态修正
export const correctQuityGroupStatus = data => fetch(host + '/quityGroup/status/correct', data, { method: 'post' });

// 权益组合 - 关联道路分页查询
export const quityGroupRoadPage = data => fetch(host + '/quityGroup/road/page', data, { method: 'post' });

// 权益组合 - 导入关联道路（Excel，multipart/form-data，data={ file }）
export const importQuityGroupRoads = data => fetch(host + '/quityGroup/road/import', data, { method: 'postImport' });

// 权益组合 - 关联产品分页查询
export const quityGroupProductPage = data => fetch(host + '/quityGroup/product/page', data, { method: 'post' });

// 权益组合 - 操作日志分页查询
export const quityGroupLogPage = data => fetch(host + '/quityGroup/log/page', data, { method: 'post' });

// 停车场路段 - 分页查询路段（GET，参数：roadLevel/pageNum/pageSize）
export const parkingRoadPage = data => fetch(host + '/admin/parking/road/page', data, { method: 'get' });

// 停车场路段 - 查询道路等级列表（GET）
export const parkingRoadLevelList = data => fetch(host + '/admin/parking/road-level/list', data, { method: 'get' });

// 文件管理 - 单文件上传 (data={ file, businessType, businessId })
export const uploadFile = data => fetch(host + '/file/upload', data, { method: 'postImport' });

// 文件管理 - 批量上传 (data={ files, businessType, businessId })
export const uploadFileBatch = data => fetch(host + '/file/upload/batch', data, { method: 'postImport' });

// 文件管理 - 文件列表（分页）
export const fileList = data => fetch(host + '/file/list', data, { method: 'get' });

// 文件管理 - 文件详情
export const getFileById = id => fetch(host + `/file/${id}`, {}, { method: 'get' });

// 文件管理 - 删除文件
export const deleteFile = id => fetch(host + `/file/${id}`, {}, { method: 'DELETE' });

// 文件管理 - 按业务查询文件
export const getFileByBusiness = data => fetch(host + '/file/business', data, { method: 'get' });

// ==================== 退款管理 ====================

// 分页查询退款申诉
export const refundComplaintPage = data => fetch(host + '/admin/pay/refunds/complaints/page', data, { method: 'post' });

// 分页查询微信支付流水
export const paymentPage = data => fetch(host + '/admin/pay/refunds/payments/page', data, { method: 'post' });

// 后台退款提示（查询指定支付流水涉及的所有权益子项可退款状态）
export const refundHint = data => fetch(host + '/admin/pay/refunds/hint', data, { method: 'post' });

// 后台主动创建退款单（paymentId 放入 body）
export const createAdminRefund = data => fetch(host + '/admin/pay/refunds/create', data, { method: 'post' });

// 初审退款申诉（complaintNo 放入 body）
export const firstAuditRefundComplaint = data => fetch(host + '/admin/pay/refunds/complaints/first-audit', data, { method: 'post' });

// 分页查询待复审退款单（固定 FIRST_APPROVED 状态）
export const refundFinalAuditPage = data => fetch(host + '/admin/pay/refunds/page', data, { method: 'post' });

// 复审退款单（refundNo 放入 body）
export const finalAuditRefund = data => fetch(host + '/admin/pay/refunds/final-audit', data, { method: 'post' });

// 额度报警判定（GET，无参，返回 body: { triggered, threshold, availableQuota, totalQuota, usedQuota, quotaStartTime, quotaEndTime, quotaStatus }）
export const quotaAlarm = data => fetch(host + '/mp/discard/quota/alarm', data, { method: 'get' });

// ==================== 会员管理 ====================

// 查询会员信息列表（分页）（GET，参数：userName/phonenumber/plateNumber/beginTime/endTime/pageNum/pageSize）
export const memberList = data => fetch(host + '/admin/member/list', data, { method: 'get' });

// 查询会员支付记录列表（分页）（GET，userId/pageNum/pageSize）
export const memberPaymentRecords = data => fetch(host + '/admin/member/payment/records', data, { method: 'get' });

// 查询会员退款记录列表（分页）（GET，userId/pageNum/pageSize）
export const memberRefundRecords = data => fetch(host + '/admin/member/refund/records', data, { method: 'get' });

// 查询会员权益购买记录列表（分页）（GET，phone/pageNum/pageSize）
export const memberRightsRecords = data => fetch(host + '/admin/member/rights/records', data, { method: 'get' });

// 查询会员权益核销记录列表（分页）（GET，phone/pageNum/pageSize）
export const memberVerificationRecords = data => fetch(host + '/admin/member/verification/records', data, { method: 'get' });

// 查询会员权益统计信息（GET，phone，返回：validCount/expiredCount/exchangedCount/pendingExchangeCount/verifiedCount/unverifiedCount）
export const memberCouponStatistics = data => fetch(host + '/admin/member/coupon/statistics', data, { method: 'get' });



// WEBPACK FOOTER //
// ./src/config/apiConfig/apiList.js